import type { FC } from 'react';
import { lazy } from 'react';
import { useOptionalPlatformSettings } from 'src/apis/monolith/use-platform-settings';

const Page = lazy(() => import('./page'));

export const ReportingAuctions: FC = () => {
  const platformSettings = useOptionalPlatformSettings();
  return <Page platformSettings={platformSettings} />;
};
